export const ALL_MEDIA_RETRIEVE_REQUESTED = 'ALL_MEDIA_RETRIEVE_REQUESTED';
export const ALL_MEDIA_RETRIEVE_SUCCEED = 'ALL_MEDIA_RETRIEVE_SUCCEED';
export const ALL_MEDIA_RETRIEVE_FAILED = 'ALL_MEDIA_RETRIEVE_FAILED';

export const GALLERY_VIEW_BACKWARD_REQUESTED = 'GALLERY_VIEW_BACKWARD_REQUESTED';
export const GALLERY_VIEW_BACKWARD_SUCCEED = 'GALLERY_VIEW_BACKWARD_SUCCEED';
export const GALLERY_VIEW_BACKWARD_FAILED = 'GALLERY_VIEW_BACKWARD_FAILED';

export const GALLERY_VIEW_FORWARD_REQUESTED = 'GALLERY_VIEW_FORWARD_REQUESTED';
export const GALLERY_VIEW_FORWARD_SUCCEED = 'GALLERY_VIEW_FORWARD_SUCCEED';
export const GALLERY_VIEW_FORWARD_FAILED = 'GALLERY_VIEW_FORWARD_FAILED';

export const GALLERY_SET_PREVIEW_IMAGE = 'GALLERY_SET_PREVIEW_IMAGE';

export const GALLERY_TRIGGER_OPEN = 'GALLERY_TRIGGER_OPEN';
export const GALLERY_TRIGGER_CLOSE = 'GALLERY_TRIGGER_CLOSE';
